// https://vuex.vuejs.org/en/getters.html

export default {
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  }
};
